import styled from 'styled-components'

const StyledLayout = styled.main`
    width:100%;
    background-color:#cbcbcb;
    min-height: 100vh;
    `

export { StyledLayout }
